import i18next from 'i18next';
import Paragraph from '../../components/Paragraph/Paragraph';
import { APPLICATION_TYPE } from '../../constants/sessionStorage';
import { APPLICATION_TYPE_STRING } from '../constants';
import { retrieveFromSessionStorage } from './sessionStorageHelper';

export const isIraAccount = () =>
  retrieveFromSessionStorage(APPLICATION_TYPE) === APPLICATION_TYPE_STRING[3];

export const iraCountryOfCitizenshipNote = (country, brokerCode) => {
  if (!isIraAccount()) {
    return;
  }

  if (country !== 'USA') {
    return (
      <Paragraph mt={12}>
        <strong>{i18next.t('common.note')}</strong>:{' '}
        {i18next.t('secureIdentity.iraNote', { brokerCode })}
      </Paragraph>
    );
  }

  return null;
};

export const iraCountryOfCitizenshipButtonDisable = (country) => {
  if (!isIraAccount()) {
    return false;
  }

  if (country !== 'USA') {
    return true;
  }

  return false;
};

export const iraPhoneNumberNotUSA = (formatedPhoneNumber) => {
  if (!formatedPhoneNumber) {
    return false;
  }

  const country = formatedPhoneNumber?.Iso3CountryCode;
  if (isIraAccount() && country !== 'USA') {
    return true;
  }

  return false;
};
